import { enrollmentConstants } from "../actions/constants/enrollmentConstants";

export const getEnrollmentReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enrollmentConstants.getEnrollmentRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case enrollmentConstants.getEnrollmentSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                enrollmentdata: action.payload
            }
        case enrollmentConstants.getEnrollmentFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const getEnrollmentParamsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enrollmentConstants.getEnrollmentParamsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case enrollmentConstants.getEnrollmentParamsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                enrollmentdata: action.payload
            }
        case enrollmentConstants.getEnrollmentParamsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const createEnrollmentReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enrollmentConstants.createEnrollmentRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case enrollmentConstants.createEnrollmentSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                enrollmentdata: action.payload
            }
        case enrollmentConstants.createEnrollmentFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case enrollmentConstants.createEnrollmentReset:
            return {
                isLoading: false,
                isSuccess: false,
                isError: false
            }
        default:
            return state;
    }
}

export const deleteEnrollmentReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enrollmentConstants.deleteEnrollmentRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case enrollmentConstants.deleteEnrollmentSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                enrollmentdelete: action.payload
            }
        case enrollmentConstants.deleteEnrollmentFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case enrollmentConstants.deleteEnrollmentReset:
            return {
                isLoading: false,
                isSuccess: false,
                isError: false
            }
        default:
            return state;
    }
}

export const getEnrollmentViewReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enrollmentConstants.enrollmentViewRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case enrollmentConstants.enrollmentViewSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                enrollmentview: action.payload
            }
        case enrollmentConstants.enrollmentViewFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const toggleEnrollmentReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enrollmentConstants.enrollmentToggleRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case enrollmentConstants.enrollmentToggleSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                enrollmentdata: action.payload
            }
        case enrollmentConstants.enrollmentToggleFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const exportEnrollmentReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enrollmentConstants.exportEnrollmentRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case enrollmentConstants.exportEnrollmentSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false
            }
        case enrollmentConstants.exportEnrollmentFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const assignApplicationReducer = (state = {}, action: any) => {
    switch (action.type) {
        case enrollmentConstants.assignApplicationRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case enrollmentConstants.assignApplicationSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                data: action.payload
            }
        case enrollmentConstants.assignApplicationFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case enrollmentConstants.assignApplicationReset:
            return {
                isLoading: false,
                isSuccess: false,
                isError: false
            }
        default:
            return state;
    }
}
